export default "assets/example-preview.png"